import { motion } from "framer-motion";
import {
  Building2,
  Hammer,
  DraftingCompass,
  Paintbrush,
  Wrench,
  ClipboardCheck,
  ArrowRight,
} from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { scrollToSection } from "@/lib/scroll";

const SERVICES = [
  {
    icon: Building2,
    title: "Konstruksi Bangunan",
    text: "Pembangunan rumah tinggal, ruko, dan gedung dari tahap pondasi hingga serah terima.",
  },
  {
    icon: Hammer,
    title: "Renovasi Rumah dan Gedung",
    text: "Peremajaan dan penataan ulang bangunan agar kembali fungsional dan tampil baru.",
  },
  {
    icon: DraftingCompass,
    title: "Desain dan Pembangunan",
    text: "Perencanaan desain yang matang dilanjutkan dengan pembangunan oleh satu tim yang sama.",
  },
  {
    icon: Paintbrush,
    title: "Pekerjaan Interior",
    text: "Penyelesaian interior yang rapi, dari plafon, lantai, hingga detail akhir ruangan.",
  },
  {
    icon: Wrench,
    title: "Pemeliharaan dan Perbaikan",
    text: "Perawatan berkala dan perbaikan kerusakan agar bangunan tetap aman digunakan.",
  },
  {
    icon: ClipboardCheck,
    title: "Konsultasi Proyek",
    text: "Diskusi kebutuhan, estimasi biaya, dan arahan langkah terbaik sebelum proyek dimulai.",
  },
];

export const Services = () => (
  <section id="layanan" className="bg-mist" aria-label="Layanan">
    <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-12 lg:py-28">
      <Reveal className="max-w-2xl">
        <Eyebrow>Layanan</Eyebrow>
        <h2 className="text-balance font-heading text-3xl font-extrabold leading-tight tracking-tight text-navy sm:text-4xl">
          Solusi Menyeluruh untuk Kebutuhan{" "}
          <span className="italic text-orange-500">Bangunan Anda</span>
        </h2>
        <p className="mt-5 text-base leading-relaxed text-slate-600">
          Dari perencanaan hingga perawatan, setiap layanan dikerjakan dengan
          standar yang sama: rapi, transparan, dan terukur.
        </p>
      </Reveal>

      <div
        data-testid="services-grid"
        className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3"
      >
        {SERVICES.map((service, i) => (
          <Reveal key={service.title} delay={i * 0.07}>
            <motion.article
              data-testid={`service-card-${i + 1}`}
              whileHover={{ y: -6 }}
              transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
              className="group flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition-shadow duration-300 hover:shadow-xl hover:shadow-navy/10 sm:p-8"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-navy transition-colors duration-300 group-hover:bg-orange-500">
                <service.icon className="h-6 w-6 text-white" aria-hidden="true" />
              </span>
              <h3 className="mt-5 font-heading text-lg font-bold text-navy">
                {service.title}
              </h3>
              <p className="mt-2.5 flex-1 text-sm leading-relaxed text-slate-600">
                {service.text}
              </p>
              <a
                href="#kontak"
                data-testid={`service-link-${i + 1}`}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection("#kontak");
                }}
                className="mt-5 inline-flex items-center gap-1.5 text-sm font-bold text-orange-600 transition-colors hover:text-orange-700"
                aria-label={`Pelajari lebih lanjut tentang ${service.title}`}
              >
                Pelajari Lebih Lanjut
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </a>
            </motion.article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
